import { styled } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';

export const MobileContainer = styled(Box)(({ isEditable }) => ({
  opacity: isEditable ? 1 : 0.6,
  backgroundColor: '#FFFFFF1A',
  borderRadius: '6px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'stretch',
  alignItems: 'center',
  minWidth: '120px',
  position: 'relative',
  width: '100%',
}));

export const MobileTopRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '14px 16px',
  boxSizing: 'border-box',
});

export const MobileLabel = styled(Typography)({
  color: 'white',
  fontSize: '18px',
  fontWeight: 400,
  textAlign: 'left',
  flex: '0 0 auto',
  marginRight: '12px',
  whiteSpace: 'nowrap',
});

export const ValueText = styled(Box)({
  color: '#FFFFFF99',
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '18px',
  textAlign: 'right',
  display: 'flex',
  alignItems: 'center',
  flex: '1 1 0',
  minWidth: 0,
  overflow: 'hidden',
  justifyContent: 'flex-end',
});

export const ValueTextLabel = styled('span')({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const DropdownArrow = styled(KeyboardArrowDown)({
  color: '#FFFFFF99',
  fontSize: '20px',
  marginLeft: '4px',
});

export const StyledPickerWrapper = styled(Box)(() => ({
  backgroundColor: '#FFFFFF14',
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',

  '& .picker-item': {
    transition: 'all 0.3s ease',
    transform: 'scale(0.8) rotateX(20deg)',
    transformOrigin: 'center',
    fontSize: '18px',
    fontWeight: 500,
    fontFamily: 'Roboto',
    color: '#FFFFFF99',
  },
  '& .picker-item.picker-item-selected': {
    transform: 'scale(1) rotateX(0deg)',
    opacity: 1,
    color: 'white !important',
  },
  '& .picker-highlight': {
    backgroundColor: '#FFFFFF2E',
    width: '315px',
    margin: '0 auto',
    left: 'auto',
    right: 'auto',
    borderRadius: '6px',
    '&::before': { display: 'none !important' },
    '&::after': { display: 'none !important' },
  },
}));
